// Auth
export const SET_AUTH0_TOKEN = 'SET_AUTH0_TOKEN';
export const SET_ADMIN_SSO_PROFILE = 'SET_ADMIN_SSO_PROFILE';
export const LOGOUT = 'LOGOUT';
export const RESET = 'RESET';

// Context
export const SET_CURRENT_CLIENT_ID = 'SET_CURRENT_CLIENT_ID';
export const SET_CURRENT_EVENT_ID = 'SET_CURRENT_EVENT_ID';

// Events
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_EVENT = 'FETCH_EVENT';
export const FETCH_EVENTS_INC_DEL = 'FETCH_EVENTS_INC_DEL';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_METADATA = 'UPDATE_EVENT_METADATA';
export const ADD_EVENT = 'ADD_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const UNDELETE_EVENT = 'UNDELETE_EVENT';

// Posts
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POST = 'FETCH_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const CLEAR_POST = 'CLEAR_POST';

// Groups
export const FETCH_GROUP = 'FETCH_GROUP';
export const FETCH_EVENT_GROUPS = 'FETCH_EVENT_GROUPS';
export const FETCH_GROUP_AGENDA = 'FETCH_GROUP_AGENDA';
export const CLEAR_GROUP = 'CLEAR_GROUP';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';
export const CREATE_OR_DUPLICATE_GROUP = 'CREATE_OR_DUPLICATE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const ADD_ATTENDEES_TO_GROUP = 'ADD_ATTENDEES_TO_GROUP';
export const REMOVE_ATTENDEES_FROM_GROUP = 'REMOVE_ATTENDEES_FROM_GROUP';

// Pages
export const SET_EVENT_PAGES = 'SET_EVENT_PAGES';
export const SET_PAGE = 'SET_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';

// Kudos
export const SET_KUDOS_BADGES = 'SET_KUDOS_BADGES';
export const SET_ATTENDEE_BADGES = 'SET_ATTENDEE_BADGES';
export const CREATE_KUDO_BADGE = 'CREATE_KUDO_BADGE';
export const UPDATE_KUDO_BADGE = 'UPDATE_KUDO_BADGE';
export const DELETE_KUDO_BADGE = 'DELETE_KUDO_BADGE';
export const UPDATE_BADGE = 'UPDATE_BADGE';
export const ADD_GROUPS_TO_KUDO_BADGE = 'ADD_GROUPS_TO_KUDO_BADGE';
export const REMOVE_GROUPS_FROM_KUDO_BADGE = 'REMOVE_GROUPS_FROM_KUDO_BADGE';
export const CLEAR_KUDO_BADGES = 'CLEAR_KUDO_BADGES';

// Leaderboards
export const SET_LEADERBOARD = 'SET_LEADERBOARD';
export const SET_EVENT_LEADERBOARDS = 'SET_EVENT_LEADERBOARDS';
export const DELETE_LEADERBOARD = 'DELETE_LEADERBOARD';

// Stats
export const FETCH_EVENT_STATS = 'FETCH_EVENT_STATS';

// Pinned
export const SET_PINNED_ANNOUNCEMENTS = 'SET_PINNED_ANNOUNCEMENTS';
export const SET_PINNED_POSTS = 'SET_PINNED_POSTS';

// Points
export const FETCH_ATTENDEE_POINT = 'FETCH_ATTENDEE_POINT';
export const FETCH_EVENT_POINT = 'FETCH_EVENT_POINT';
export const DELETE_EVENT_POINT = 'DELETE_EVENT_POINT';
export const UPDATE_EVENT_POINT = 'UPDATE_EVENT_POINT';
export const CREATE_EVENT_POINT = 'CREATE_EVENT_POINT';
export const CREATE_ATTENDEE_POINT = 'CREATE_ATTENDEE_POINT';
export const UPDATE_ATTENDEE_POINT = 'UPDATE_ATTENDEE_POINT';
export const DELETE_ATTENDEE_POINT = 'DELETE_ATTENDEE_POINT';

// Announcements
export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS';
export const CLEAR_ANNOUNCEMENTS = 'CLEAR_ANNOUNCEMENTS';
export const CREATE_ANNOUNCEMENT = 'CREATE_ANNOUNCEMENT';
export const SEND_ANNOUNCEMENT = 'SEND_ANNOUNCEMENT';
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT';
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT';
export const ADD_GROUPS_TO_ANNOUNCEMENT = 'ADD_GROUPS_TO_ANNOUNCEMENT';
export const REMOVE_GROUPS_FROM_ANNOUNCEMENT = 'REMOVE_GROUPS_FROM_ANNOUNCEMENT';

// Domain
export const SET_DOMAIN = 'SET_DOMAIN';
export const DELETE_DOMAIN = 'DELETE_DOMAIN';

// Library
export const UPLOAD_LIBRARY_MEDIA = 'UPLOAD_LIBRARY_MEDIA';
export const CREATE_LIBRARY = 'CREATE_LIBRARY';
export const DELETE_LIBRARY = 'DELETE_LIBRARY';
export const UPDATE_LIBRARY = 'UPDATE_LIBRARY';
export const FETCH_LIBRARY = 'FETCH_LIBRARY';
export const CLEAR_LIBRARY = 'CLEAR_LIBRARY';
export const UPDATE_CHILD_LIBRARY = 'UPDATE_CHILD_LIBRARY';
export const ADD_CHILD_LIBRARY = 'ADD_CHILD_LIBRARY';
export const DELETE_CHILD_LIBRARY = 'DELETE_CHILD_LIBRARY';
export const ADD_GROUPS_TO_LIBRARY = 'ADD_GROUPS_TO_LIBRARY';
export const REMOVE_GROUPS_FROM_LIBRARY = 'REMOVE_GROUPS_FROM_LIBRARY';

// Agenda
export const FETCH_AGENDA = 'FETCH_AGENDA';
export const FETCH_AGENDA_ITEM = 'FETCH_AGENDA_ITEM';
export const CLEAR_AGENDA = 'CLEAR_AGENDA';
export const CLEAR_AGENDA_ITEM = 'CLEAR_AGENDA_ITEM';
export const UPDATE_AGENDA_ITEM = 'UPDATE_AGENDA_ITEM';
export const CREATE_AGENDA_ITEM = 'CREATE_AGENDA_ITEM';
export const DELETE_AGENDA_ITEM = 'DELETE_AGENDA_ITEM';
export const ADD_GROUPS_TO_AGENDA_ITEM = 'ADD_GROUPS_TO_AGENDA_ITEM';
export const REMOVE_GROUPS_FROM_AGENDA_ITEM = 'REMOVE_GROUPS_FROM_AGENDA_ITEM';
export const ADD_MATERIAL_TO_AGENDA_ITEM = 'ADD_MATERIAL_TO_AGENDA_ITEM';
export const DELETE_MATERIAL_FROM_AGENDA_ITEM = 'DELETE_MATERIAL_FROM_AGENDA_ITEM';
export const UPDATE_MATERIAL = 'UPDATE_MATERIAL';
export const ADD_GROUPS_TO_MATERIAL = 'ADD_GROUPS_TO_MATERIAL';
export const REMOVE_GROUPS_FROM_MATERIAL = 'REMOVE_GROUPS_FROM_MATERIAL';
export const UPDATE_SELECTED_PERSON_OR_TRACK = 'UPDATE_SELECTED_PERSON_OR_TRACK';
export const UPDATE_SELECTED_VIEW = 'UPDATE_SELECTED_VIEW';
export const UPDATE_SELECTED_PERSON_OR_TRACK_NAME = 'UPDATE_SELECTED_PERSON_OR_TRACK_NAME';
export const CLEAR_AGENDA_FILTER_AND_SCROLL = 'CLEAR_AGENDA_FILTER_AND_SCROLL';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

// Attendees
export const SET_ATTENDEES = 'SET_ATTENDEES';
export const CLEAR_ATTENDEES = 'CLEAR_ATTENDEES';
export const CREATE_ATTENDEE = 'CREATE_ATTENDEE';
export const UPDATE_ATTENDEE = 'UPDATE_ATTENDEE';
export const DELETE_ATTENDEE = 'DELETE_ATTENDEE';
export const REMOVE_MANY_ATTENDEES_FROM_EVENT = 'REMOVE_MANY_ATTENDEES_FROM_EVENT';
export const SET_SINGLE_ATTENDEE = 'SET_SINGLE_ATTENDEE';
export const SET_ATTENDEE_METADATA = 'SET_ATTENDEE_METADATA';
export const SET_ATTENDEE_AGENDA = 'SET_ATTENDEE_AGENDA';
export const SET_PUSH_ANNOUNCEMENT_TOKENS = 'SET_PUSH_ANNOUNCEMENT_TOKENS';
export const UPDATE_ATTENDEE_METADATA = 'UPDATE_ATTENDEE_METADATA';
export const UPDATE_ATTENDEE_AGENDA_ITEM = 'UPDATE_ATTENDEE_AGENDA_ITEM';
export const DUPLICATE_ATTENDEE_AGENDA_ITEM = 'DUPLICATE_ATTENDEE_AGENDA_ITEM';
export const DELETE_ATTENDEE_AGENDA_ITEM = 'DELETE_ATTENDEE_AGENDA_ITEM';
export const ADD_MANY_GROUPS_TO_ATTENDEE = 'ADD_MANY_GROUPS_TO_ATTENDEE';
export const REMOVE_MANY_GROUPS_FROM_ATTENDEE = 'REMOVE_MANY_GROUPS_FROM_ATTENDEE';
export const CLEAR_ATTENDEE_DATA = 'CLEAR_ATTENDEE_DATA';

// Audit
export const SET_AUDIT = 'SET_AUDIT';
export const CLEAR_AUDIT = 'CLEAR_AUDIT';

// Event Syncs
export const FETCH_EVENT_SYNCS = 'FETCH_EVENT_SYNCS';
export const FETCH_EVENT_REPORT = 'FETCH_EVENT_REPORT';
export const CLEAR_EVENT_SYNCS = 'CLEAR_EVENT_SYNCS';

// Media
export const FETCH_MEDIA = 'FETCH_MEDIA';
export const FETCH_EVENT_MEDIA = 'FETCH_EVENT_MEDIA';
export const CREATE_MEDIA = 'CREATE_MEDIA';
export const UPDATE_MEDIA = 'UPDATE_MEDIA';
export const DELETE_MEDIA = 'DELETE_MEDIA';
export const CLEAR_MEDIA = 'CLEAR_MEDIA';
export const CLEAR_EVENT_MEDIA = 'CLEAR_EVENT_MEDIA';

// Widgets
export const SET_WIDGETS = 'SET_WIDGETS';
export const CLEAR_WIDGETS = 'CLEAR_WIDGETS';
export const CREATE_WIDGET = 'CREATE_WIDGET';
export const UPDATE_WIDGET = 'UPDATE_WIDGET';
export const DELETE_WIDGET = 'DELETE_WIDGET';

// Admins
export const FETCH_ALL_ADMINS = 'FETCH_ALL_ADMINS';
export const SET_ADMIN = 'SET_ADMIN';

// Notification Preferences
export const SET_NOTIFICATION_TYPES = 'SET_NOTIFICATION_TYPES';
export const SET_EVENT_PREFERENCES = 'SET_EVENT_PREFERENCES';
export const UPDATE_EVENT_PREFERENCE = 'UPDATE_EVENT_PREFERENCE';

// Checkins
export const FETCH_EVENT_CHECKIN = 'FETCH_EVENT_CHECKIN';
export const UPDATE_EVENT_CHECKIN = 'UPDATE_EVENT_CHECKIN';
export const CREATE_EVENT_CHECKIN = 'CREATE_EVENT_CHECKIN';

// Locations
export const SET_EVENT_LOCATIONS = 'SET_EVENT_LOCATIONS';
export const CREATE_LOCATION = 'CREATE_LOCATION';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';

// Photobooth
export const FETCH_PHOTOBOOTH_MEDIA = 'FETCH_PHOTOBOOTH_MEDIA';
export const FETCH_PHOTOBOOTH = 'FETCH_PHOTOBOOTH';

// Clients
export const FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
export const SET_CLIENT = 'SET_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';

// Connections
export const FETCH_EVENT_CONNECTION = 'FETCH_EVENT_CONNECTION';
export const UPDATE_EVENT_CONNECTION = 'UPDATE_EVENT_CONNECTION';
export const CREATE_EVENT_CONNECTION = 'CREATE_EVENT_CONNECTION';
export const FETCH_EVENT_CONNECTIONS = 'FETCH_EVENT_CONNECTIONS';
export const DELETE_CONNECTION = 'DELETE_CONNECTION';

// Podcasts
export const FETCH_PODCASTS = 'FETCH_PODCASTS';
export const FETCH_PODCAST = 'FETCH_PODCAST';
export const CREATE_PODCAST = 'CREATE_PODCAST';
export const UPDATE_PODCAST = 'UPDATE_PODCAST';
export const DELETE_PODCAST = 'DELETE_PODCAST';
export const CLEAR_PODCAST = 'CLEAR_PODCAST';
export const CLEAR_PODCASTS = 'CLEAR_PODCASTS';
